import { render, staticRenderFns } from "./InitAccount.vue?vue&type=template&id=0d6b83ef&"
import script from "./InitAccount.vue?vue&type=script&lang=js&"
export * from "./InitAccount.vue?vue&type=script&lang=js&"
import style0 from "./InitAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
